import { Button, Modal } from "react-bootstrap";
import styled from "styled-components";

const StyledParagraph = styled.p`
  text-align: center;
`;

export default function ConfirmRemovePropertyModal({
  onConfirm,
  onCancel,
}: {
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Remove Property</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <StyledParagraph>
          Are you sure you want to remove this property?
        </StyledParagraph>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="danger" onClick={onConfirm}>
          Remove
        </Button>
      </Modal.Footer>
    </>
  );
}
